(ns frontend.test.validation.event
  (:require
   [potpuri.core :as potpuri]
   [re-frame.core :as rf]
   [frontend.test.validation.model :as m]
   [frontend.test.validation.utils :as utils]))

(defn update-value
  [{:keys [db]} [_ {:keys [entity-id attribute value] :as ctx}]]
  (let [new-db (-> db
                   (update-in (m/entity-edits-full-path ctx)
                              assoc attribute value))]
    #_(prn ">update-value" (m/entity-edits-full-path ctx)
         entity-id attribute value)
    {:db new-db}))

(rf/reg-event-fx
 m/update-value
 []
 update-value)

(defn clear-state
  [{:keys [db]} [_ {:keys [entity-id attribute value] :as ctx}]]
  (let [new-db (-> db
                   (potpuri/dissoc-in (m/i-root ctx)))]
    #_(prn ">update-value" (m/entity-edits-full-path ctx)
           entity-id attribute value)
    {:db new-db}))

(rf/reg-event-fx
 m/clear-state
 []
 clear-state)

(defn try-save
  [{:keys [db]} [_ ctx]]
  (let [entity-edits (get-in db (m/entity-edits-full-path ctx))
        validations (utils/validate-all
                     {:entity-edits entity-edits}
                     [nil ctx])
        new-db (cond-> db
                 (seq validations)
                 (assoc-in (m/entity-errors-full-path ctx) validations)

                 (empty? validations)
                 (potpuri/dissoc-in (m/errors-full-path ctx)))]
    #_(prn ">update-value" (m/entity-edits-full-path ctx)
           entity-id attribute value)
    (when (empty? validations)
      (prn ">validation passed => SAVE"))
    (when (seq validations)
      (prn ">validation failed => display errors" validations))
    {:db new-db}))

(rf/reg-event-fx
 m/try-save
 []
 try-save)
